import { SVGProps, memo } from 'react';

const Star = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.65872 0.172681C5.73356 -0.0576465 6.05941 -0.0576468 6.13425 0.172681L7.35495 3.92961C7.38842 4.03261 7.48441 4.10235 7.59271 4.10235H11.543C11.7852 4.10235 11.8859 4.41226 11.6899 4.55461L8.49409 6.87652C8.40647 6.94018 8.36981 7.05302 8.40328 7.15603L9.62397 10.913C9.69881 11.1433 9.43519 11.3348 9.23926 11.1925L6.04343 8.87055C5.95581 8.80689 5.83716 8.80689 5.74954 8.87055L2.5537 11.1925C2.35778 11.3348 2.09416 11.1433 2.16899 10.913L3.38969 7.15603C3.42316 7.05302 3.3865 6.94018 3.29888 6.87652L0.103043 4.55461C-0.0928857 4.41226 0.00780791 4.10235 0.249989 4.10235H4.20026C4.30856 4.10235 4.40455 4.03261 4.43802 3.92961L5.65872 0.172681Z'
      fill='white'
    />
  </svg>
);

export default memo(Star);
